import { ApiErrorResponseFromJSON } from '@ibe/api';
import { action, computed, observable, makeObservable } from 'mobx';
import Service from './Service';

class LoginService extends Service {
  public tokenValue: string | null = null;

  constructor() {
    super();

    makeObservable(this, {
      tokenValue: observable,
      token: computed,
      refreshToken: action
    });
  }

  get token(): string | null {
    return this.tokenValue;
  }

  async refreshToken(): Promise<string | null> {
    if (!this.api) {
      throw new Error(this.ERR_NO_API);
    }
    if (!this.authService) {
      throw new Error(this.ERR_NO_AUTHORIZATION_SERVICE);
    }
    try {
      this.tokenValue = await this.api.refreshToken();
      if (this.tokenValue) {
        this.authService.fromJwt(this.tokenValue);
      }
      return this.tokenValue;
    } catch (e) {
      throw ApiErrorResponseFromJSON(await (e as Response).json());
    }
  }
}

export default LoginService;
